import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const plivo = defineConnector({
  identifier: "plivo",
  name: "Plivo",
  tagLine: "Cloud communications",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://api\\.plivo\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: app.secret.authId,
      password: app.secret.authToken,
    }),
  steps: [
    {
      title: "Get your credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Plivo console](https://console.plivo.com/), find your Auth ID and Auth Token on the dashboard.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Auth ID",
          required: true,
          target: { kind: "secrets", field: "authId" },
        },
        {
          kind: "input",
          label: "Auth token",
          required: true,
          target: { kind: "secrets", field: "authToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.plivo.com/v1/Account/",
  },
});
